import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute, Router} from "@angular/router";
import {TypeProductService} from "../../../services/type-product.service";
import {BrandService} from "../../../services/brand.service";
import {first} from "rxjs/operators";

@Component({
  selector: 'app-brand-type-product-add-edit',
  templateUrl: './brand-type-product-add-edit.component.html',
  styleUrls: ['./brand-type-product-add-edit.component.scss']
})
export class BrandTypeProductAddEditComponent implements OnInit {

    form: FormGroup;
    submitted = false;
    loading = false;
    id: number;
    update = false;
    type_product: any = [];
    brands: any = [];
    select_brand: any;
    brands_data: any = [];

    constructor(
        private formBuilder: FormBuilder,
        private toastrService: ToastrService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private typeProductService: TypeProductService,
        private brandService: BrandService,
    ) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            brand_id: null,
            brands: null,
        });

        this.id = this.activatedRoute.snapshot.params['id'];

        if (this.id) {
            this.update = true;
            this.typeProductService.getById(this.id).subscribe(response => {
                this.form.patchValue(response.data);
                response.brand.forEach((data, index) => {
                    if (data.brand) {
                        this.brands_data.push(data.brand);
                    }
                })
                this.type_product = response.data;
            }, error => {
                this.router.navigate(['/brand-type-products']);
            });
        }

        this.getBrands();
    }

    onSelectBrand(e) {
        this.select_brand = e.target.value;
    }

    addBrand() {
        if (this.select_brand) {
            this.brands.forEach(item => {
                if (item.id == this.select_brand) {
                    let duplicate = this.brands_data.filter(data => data.id == this.select_brand);
                    if (duplicate.length < 1) {
                        this.brands_data.push(item);
                    }
                }
            });
        }
    }

    deleteBrand(item: any){
        this.brands_data.forEach((data, index) => {
            if (data.id == item) {
                this.brands_data.splice(index, 1);
            }
        })
    }

    get f() {
        return this.form.controls;
    }

    getBrands() {
        this.brandService.getAll().subscribe(response => {
            this.brands = response.data;
        }, error => {
            this.toastrService.error(error, 'Error');
        });
    }

    sendForm() {
        this.submitted = true;
        if (!this.form.valid) {
            return;
        }
        if (this.brands_data.length == 0) {
            this.toastrService.error( 'Agrege una marca!');
            return;
        }
        this.form.controls.brands.setValue(this.brands_data);
        let item = Object.assign({}, this.form.value);

        if (this.update) {
            item.id = this.id;
            this.typeProductService.update(item)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/brand-type-products']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        } else {
            this.typeProductService.store(item)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/brand-type-products']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        }
    }

}
